import React, { useEffect, useState } from "react";
import "../styles/teamEvent.css";
import { AnimatePresence, AnimateSharedLayout, motion } from "framer-motion";
// import { events } from "../eventsData";
import TeamList from "./TeamList";
import EventItem from "./EventItem";
import firebase from "../firebase";

const TeamEvent = ({ match }) => {
  let currentIdName = "";
  let id = match.url.split("/")[2];

  if (id) {
    currentIdName = parseInt(match.url.split("/")[3]);
  } else {
    currentIdName = match.url;
  }
  const filterEvent = (e) => {
    return currentIdName === parseInt(e.id);
  };
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const refTeams = firebase.firestore().collection("teams");
  function getTeams() {
    setLoading(!loading);
    refTeams
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setTeams(items);
      });
    setLoading(!loading);
  }
  const refEvents = firebase.firestore().collection("events");
  function getEvents(teamID) {
    setLoading(!loading);
    refEvents
      .where("teamID", "==", teamID)
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setEvents(items);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getTeams();
    getEvents(match.url.split("/")[2]);
  }, []);
  const event = events.filter((e) => e.id === match.url.split("/")[3]);
  // console.log(match.url.split("/"));
  // console.log(events);
  // console.log(event);

  return (
    <motion.div className="event-wrapper p-10">
      <AnimateSharedLayout type={"crossfade"}>
        <motion.div className="container">
          <TeamList currentId={currentIdName} selectedId={id} />
          <AnimatePresence>
            {event.length > 0 && (
              <EventItem
                currentId={currentIdName}
                id={id}
                team={teams.filter((t) => t.id === event[0].teamID)[0].name}
                url={event[0].url}
                title={event[0].name}
                description={event[0].description}
                image={event[0].profileImage}
                schedule={event[0].schedule}
              />
            )}
          </AnimatePresence>
        </motion.div>
      </AnimateSharedLayout>
    </motion.div>
  );
};

export default TeamEvent;
